module.exports = __webpack_public_path__ + "img/icon_home.fe0a6ed7.svg";